import Vue from "vue";

const store = {
  namespaced: true,
  state: {
    list: null,
    active: null,
    cache: {},
  },
  mutations: {
    cache(state, value) {
      const keys = Object.keys(value);
      const cache = { ...state.cache };

      for (const key of keys) {
        cache[key] = {
          ...cache[key],
          ...value[key],
        };
      }

      state.cache = cache;
    },
    clearCache(state) {
      state.cache = {};
    },
    setList(state, list) {
      state.list = list;
    },
    setActive(state, page) {
      if (page) {
        localStorage.setItem("pageId", page.id);
        state.active = page;
      } else {
        localStorage.removeItem("pageId");
        state.active = null;
      }
    },
  },
  actions: {
    async fetch({ commit }) {
      const { data } = await Vue.prototype.$api.Page.query();
      commit("setList", data);

      const pageId = localStorage.getItem("pageId");
      const page = data.find((s) => s.id == pageId);

      if (page) commit("setActive", page);
    },
  },
  getters: {
    list: (state) => state.list,
  },
};

export default store;
